var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ 'container': !_vm.fluid, 'container-fluid': _vm.fluid }]},[(_vm.showTitle)?_c('header',{staticClass:"row"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }